<template>
	<div class="container__menuuser">
		<MenuIconCard>
			<template #icon>
				<div class="container__menuuser__notification">
					<div
						:class="[
							'container__menuuser__notification__alert',
							temNotificacoes ? 'notification-enabled' : 'notification-disabled ',
						]"
					/>
					<i class="fas fa-bell" />
				</div>
			</template>
			<template #card>
				<MenuCardNotifications @mudarNotificacao="setarSeExisteNotificacaoNova" />
			</template>
		</MenuIconCard>

		<MenuIconCard>
			<template #icon>
				<div class="container__menuuser__profile">
					<img
						class="container__menuuser__profile__avatar"
						:src="fotoUrl"
						alt=""
						@error="onImageError"
					/>
				</div>
			</template>
			<template #card>
				<MenuCardUser />
			</template>
		</MenuIconCard>
	</div>
</template>

<script>
import MenuCardNotifications from '../MenuCardNotifications/MenuCardNotifications'
import MenuCardUser from '../MenuCardUser/MenuCardUser'
import MenuIconCard from '../MenuIconCard/MenuIconCard'
import { refreshFotoUrl } from '../../../services/profilePhoto'

export default {
	components: { MenuIconCard, MenuCardNotifications, MenuCardUser },
	data: () => {
		return {
			temNotificacoes: false,
			temUsername: false,
			// reativo: inicia do localStorage e é renovado no mounted
			fotoUrlAtual: localStorage.getItem('fotoUrl') || '',
			// quando o SAS da fotoUrl expira (403), cai no avatar de iniciais
			imageFailed: false,
		}
	},
	computed: {
		fotoUrl() {
			if (!this.fotoUrlAtual || this.imageFailed) {
				// Cores padrão do ui-avatars; letras em negrito para não parecerem apagadas ao lado do
				// globo e do sino. size=64 deixa nítido em telas de alta densidade (25 ficava borrado).
				return `https://ui-avatars.com/api/?name=${this.emailFormatado}&size=64&bold=true`
			}
			return this.fotoUrlAtual
		},
		email() {
			return localStorage.getItem('username')
		},
		emailFormatado() {
			return this.email.split('@')[0]
		},
	},
	async mounted() {
		// renova o SAS da foto (o gravado no login expira em ~30min)
		const novaFotoUrl = await refreshFotoUrl()
		if (novaFotoUrl !== null) {
			this.fotoUrlAtual = novaFotoUrl
			this.imageFailed = false
		}
	},
	methods: {
		/**
		 * Método que troca o valor de (temNotificacoes)
		 */
		setarSeExisteNotificacaoNova(exitemNotificacoes) {
			this.temNotificacoes = exitemNotificacoes
		},

		onImageError() {
			this.imageFailed = true
		},
	},
}
</script>

<style scoped>
.container__menuuser__notification {
	position: relative;
}

.container__menuuser__notification__alert {
	background-color: rgb(var(--color-default));
	border-radius: 50%;
	position: absolute;
	right: 0;
	top: -0.2rem;
	cursor: pointer;
	transform-origin: center;
	transition: all 0.1s linear;
}

.notification-disabled {
	height: 0px;
	width: 0px;
}

.notification-enabled {
	height: 10px;
	width: 10px;
}

.container__menuuser {
	height: 100%;
	display: flex;
	align-items: center;
}

/* Avatar de 22px centralizado na barra, na mesma altura do sino: é o mesmo tamanho visual
   do globo (SVG de 24px com ~22px de desenho) e do sino. */
.container__menuuser__profile {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	cursor: pointer;
	margin-left: 0.5rem;
}

.container__menuuser__profile__avatar {
	flex-shrink: 0;
	height: 22px;
	width: 22px;
	border-radius: 50%;
	object-fit: cover;
}

.fas {
	font-size: 1.2rem;
	color: rgb(var(--color-primary));
	padding-left: 0.5rem;
	padding-right: 0.5rem;
	cursor: pointer;
}
</style>
